import PuzzleService from '_services/rest/modules/puzzle';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    huntingWords: null,
    hasChanges: false,
  },
  mutations: {
    setHuntingWords(state, huntingWords) {
      state.huntingWords = huntingWords;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setHuntingWords({ commit }, model) {
      commit('setHuntingWords', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getHuntingWords({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setHuntingWords', response);
        })
        .catch(error => {
          handleResourceLoadError(dispatch, error, 'admin-hunting-words-list');
        });
    },
  },
};
